import createDiscontinuationElement from "./createDiscontinuationElement";

export default (runInfoData, isDiscontinuation = false) => {

  const r = {
    data: runInfoData,
    isDiscontinuation
  };
  const init = () => {
    r.root = document.querySelector('.le-race-date');
    r.root.querySelector('.le-race-date__day').textContent = r.data.date;
    r.root.querySelector('.le-race-date__week').textContent = r.data.week;

    const zone = r.root.querySelector('.le-race-date__zone');
    zone.textContent = r.data.zone;
    zone.classList.remove('_night', '_day');
    zone.classList.add(r.data.cls);

    if (r.isDiscontinuation) {
      const raceHeaderDate = document.querySelector('.c-race-header__date');
      raceHeaderDate.appendChild(createDiscontinuationElement(raceHeaderDate.className))
    }

    r.root.classList.remove('_skelton');
    r.root.removeAttribute('aria-hidden');
  }

  init()
}
